import { render, staticRenderFns } from "./DialogPageBooks.vue?vue&type=template&id=96d404ac&scoped=true&"
import script from "./DialogPageBooks.vue?vue&type=script&lang=js&"
export * from "./DialogPageBooks.vue?vue&type=script&lang=js&"
import style0 from "./DialogPageBooks.vue?vue&type=style&index=0&id=96d404ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d404ac",
  null
  
)

export default component.exports